// Split out of ChatSession.js: llm/ContentBlock.js and llm/ToolUseBlock.js both need
// renderLLMMarkdown, and ChatSession.js imports llm/Conversation.js (which reaches
// ContentBlock.js/ToolUseBlock.js), which made them a circular import.
import { blunt } from "../tools";
import { prepareMarkdown } from "../markdown/utils";
import { renderMarkdown } from "../markdown/markdown-factory";
import { MDCollapsibleText } from "../components/results-grid/grid-row/MDCollapsibleContent";

export const fixLLMMarkdown = (s) => {
  // Minimal normalization for assistant-generated markdown
  // Most workarounds removed - markdown-to-jsx v9 with optimizeForStreaming handles most edge cases
  const patched = (s || "").trim()
    // Strip trailing standalone dash to prevent setext H2 interpretation during streaming
    // markdown-to-jsx sees "text\n-" as a header underline, causing size jumps
    .replace(/\n-\s*$/g, "")
    // Shorten long FP numbers for readability (not a markdown bug, just cleaner output)
    .replace(/\b(\d+\.\d\d\d)\d+\b/g, "$1")
    // Convert <br class='newline' /> to actual newlines in LLM output.
    // These tags are generated by the template interpolation pipeline for database content,
    // but LLMs sometimes emit them literally. prepareMarkdown preserves them for the template
    // pipeline, so we strip them here before that step.
    .replace(/<br\s+class=['"]newline['"]\s*\/>/gi, "\n")
    // Replace [GENE_SYMBOL] bracket notation with bold markdown.
    // LLMs learn this convention from gene dataset titles and emit it in their responses,
    // but brackets in link text (and standalone) break markdown rendering.
    // Only match uppercase gene-like symbols (1-10 chars) not followed by ]( which would be a link.
    .replace(/\[([A-Za-z][A-Za-z0-9]{0,9})\](?!\()/g, "**$1**");
  return prepareMarkdown(patched === s ? s : patched);
};
export const renderLLMMarkdown = (md, trapErrors = true, rawMarkdown = false) => {
  // For raw markdown (like welcome onboarding), skip prepareMarkdown to preserve HTML structure
  if (rawMarkdown) {
    return renderMarkdown({
                            markdown: md || "",
                            trapErrors,
                            prepare: false,  // Skip prepareMarkdown processing
                            optimizeForStreaming: false,
                            overrides: {
                              MDCollapsibleText: { component: MDCollapsibleText }
                            }
                          });
  }

  // Normal LLM output processing
  const markdown = fixLLMMarkdown(blunt(md || ""));
  // Note: llm-training and thinking components are now provided globally via
  // DEFAULT_COMPONENT_OVERRIDES in markdown-factory.js, so no need to pass them here
  return renderMarkdown({
                          markdown,
                          trapErrors,
                          optimizeForStreaming: true  // Enable streaming support for LLM content
                        });
};
